import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import { AppBar, Button, Skeleton, Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid/Grid";
import Paper from "@mui/material/Paper/Paper";
import Typography from "@mui/material/Typography/Typography";
import { Box, Stack } from "@mui/system";

import { EmptyState } from "./EmptyStat";
import AddIcon from "@mui/icons-material/Add";
import ScopeHeader from "components/ScopeHeader";
import { SitesJSON } from "utils/dummy";
import MachineCardItem2 from "components/MachineCardItem2";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";

function SitePage() {
  interface SiteData {
    [siteId: string]: {
      name: string;
      nodeid: string;
      hasarea: Array<{ area: Record<string, any> }>;
      order: number;
    };
  }

  const siteData: SiteData = useBoundStore((state) => state.subscribedSites);

  const lang: any = useBoundStore((state) => state.lang);


  let location = useLocation();

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<any>("");

  const params = new URLSearchParams(location.search);

  useEffect(() => {
    let sitenodeid: any = params.get("sitenodeid");

    setActiveTab(
      sitenodeid
        ? Object.keys(siteData).findIndex((a) => a === sitenodeid)
        : Object.keys(siteData).length
        ? "0"
        : ""
    );
  }, [params]);

  function CustomTabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box
            sx={{
              p: 0,
              backgroundColor: "white",
              marginTop: "3%",
              borderRadius: "4px",
              padding: "24px",
            }}
          >
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  let no_sites = location.search.includes("no_sites");

  const handleTabChange = (event: any, newValue: any) => {
    setActiveTab(newValue);
    navigate("?sitenodeid=" + event.target.id.split("full-width-tab-")[1]);
  };

  function a11yProps(index: any) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  let hasequip: any = "";
  return (
    <>
      {no_sites ? (
        <Paper sx={{ padding: "10px" }}>
          <EmptyState
            heading={i18n(lang).sites}
            title={i18n(lang).no_site_title}
            description={
              i18n(lang).no_site_desc
            }
            icon={
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18 16.7485C18 17.5135 17.38 18.1335 16.615 18.1335C15.851 18.1335 15.23 17.5135 15.23 16.7485V13.5185C15.23 12.7535 15.851 12.1335 16.615 12.1335C17.38 12.1335 18 12.7535 18 13.5185V16.7485ZM13.385 16.7485C13.385 17.5135 12.765 18.1335 12 18.1335C11.235 18.1335 10.615 17.5135 10.615 16.7485V13.5185C10.615 12.7535 11.235 12.1335 12 12.1335C12.765 12.1335 13.385 12.7535 13.385 13.5185V16.7485ZM8.77 16.7485C8.77 17.5135 8.149 18.1335 7.385 18.1335C6.62 18.1335 6 17.5135 6 16.7485V13.5185C6 12.7535 6.62 12.1335 7.385 12.1335C8.149 12.1335 8.77 12.7535 8.77 13.5185V16.7485ZM12 7.13352V4.00152C12 3.20352 11.109 2.72652 10.445 3.16952L3.891 6.53952C3.334 6.91052 3 7.53552 3 8.20352V19.1335C3 20.2375 3.896 21.1335 5 21.1335H19C20.104 21.1335 21 20.2375 21 19.1335V4.00152C21 3.20352 20.109 2.72652 19.445 3.16952L12 7.13352Z"
                  fill="black"
                  fill-opacity="0.5"
                />
              </svg>
            }
            hasButton
            button={
              <div style={{ marginTop: "20px", marginBottom: "50px" }}>
                <Button
                  onClick={() => {
                    navigate("/create-site");
                  }}
                  startIcon={<AddIcon />}
                  variant="contained"
                  color="primary"
                >
                  {i18n(lang).create_new_site}
                </Button>
              </div>
            }
          />{" "}
        </Paper>
      ) : (
        <section>
          <ScopeHeader
            bgColor="#B21412"
            bgImage="images/scope_header.png"
            txtColor="#FFFFFF"
            title={i18n(lang)?.site_scope_title}
            description={i18n(lang)?.site_scope_description}
          />

          <Grid
            container
            spacing={3}
            direction="row"
          >
            <Grid item xs={12}>
              <Box sx={{ bgcolor: "background.paper" }}>
                <AppBar
                  className="appBar"
                  position="static"
                  sx={{ borderRadius: "4px" }}
                  variant="elevation"
                >
                  <Tabs
                    value={+activeTab}
                    onChange={(event, newValue) =>
                      handleTabChange(event, newValue)
                    }
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label=""
                  >
                    {siteData &&
                      Object.keys(siteData).map((key, index) => (
                        <Tab
                          key={siteData[key]?.nodeid}
                          label={siteData[key].name}
                          {...a11yProps(siteData[key]?.nodeid)}
                          className="tab"
                        />
                      ))}
                  </Tabs>
                </AppBar>
              </Box>

              {siteData &&
                Object.keys(siteData).map((key: any, index) => {
                  let value: any = siteData[key];

                  return (
                    <CustomTabPanel value={+activeTab} index={index}>
                      <>
                        <header>
                          <Grid
                            container
                            spacing={3}
                            justifyContent="space-between"
                          >
                            <Grid item>
                              <Typography variant="h5">
                                {location.state && location.state.from == "area"
                                  ? ""
                                  : value.name}{" "}
                                {
                                  <Link
                                    to="/create-site"
                                    state={{
                                      nodeid: value?.nodeid,
                                      name: value?.name,
                                      city: value?.city,
                                      zipcode: value?.zipcode,
                                      street: value?.street,
                                      country: value?.country,
                                      address: value?.siteid,
                                      order: value?.order,
                                      pageType: "edit",
                                    }}
                                  >
                                    <ModeEditOutlinedIcon
                                      fontSize="small"
                                      titleAccess={i18n(lang).edit}
                                      className="editLinkIcon"
                                    />
                                  </Link>
                                }
                              </Typography>
                            </Grid>
                          </Grid>
                        </header>

                        <div style={{ width: "100%", marginTop: "3%" }}>
                          {value != undefined ? (
                            Object.keys(value).length > 0 ? (
                              value?.hasarea?.length ? (
                                value?.hasarea.map((x: any, key: any) => {
                                  var name = x?.area?.name;
                                  return (
                                    <div
                                      key={key}
                                      style={{
                                        width: "100%",
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              margin: "0px 0px 20px 0px",
                                            }}
                                          >
                                            {x?.area?.name}{" "}
                                            {
                                              <Link
                                                to={
                                                  "/create-area?nodeid=" +
                                                  x?.area?.nodeid
                                                }
                                                state={{
                                                  nodeid: x?.area.nodeid,
                                                  name: x?.area?.name,
                                                  areaid: x?.area?.areaid,
                                                  pageType: "edit",
                                                  sitename: value.name,
                                                  sitenodeid: value.nodeid,
                                                  order: x?.area?.order,
                                                }}
                                              >
                                                <ModeEditOutlinedIcon
                                                  fontSize="small"
                                                  titleAccess={i18n(lang).edit}
                                                  className="editLinkIcon"
                                                />
                                              </Link>
                                            }
                                          </div>

                                          <Link
                                            to="/create-equipment"
                                            state={{
                                              pageType: "add",
                                              nodeid: value?.nodeid,
                                              sitename: value.name,
                                              sitenodeid: value.nodeid,
                                              areanodeid: x?.area?.nodeid,
                                              areaname: x?.area?.name,
                                              from:"sitePage"
                                            }}
                                            style={{
                                              color: "#212121",
                                            }}
                                          >
                                            <Button
                                              startIcon={<AddIcon />}
                                              variant="contained"
                                              color="primary"
                                              style={{
                                                margin: "0px 0px 20px 10px",
                                              }}
                                            >
                                              {i18n(lang)?.new_equipment_btn}
                                            </Button>
                                          </Link>
                                        </div>
                                      </Typography>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {
                                          (hasequip =
                                            x?.area?.hasequipment?.map(
                                              (y: any, key: any) => {
                                                return (
                                                  <div
                                                    key={key}
                                                    className="sitePageMachineWrapper"
                                                    style={{
                                                      width: "49%",
                                                      paddingBottom: "20px",
                                                    }}
                                                  >
                                                    <Link
                                                      to="/machine-detail"
                                                      state={{
                                                        nodeid:
                                                          y?.equipment?.nodeid,
                                                        pool: name,
                                                        sitenodeid:
                                                          value.nodeid,
                                                        areanodeid:
                                                          x?.area.nodeid,
                                                        area: x,
                                                        from: "area",
                                                        machineNodeId:
                                                          y?.equipment?.nodeid,
                                                      }}
                                                    >
                                                      <MachineCardItem2
                                                        i18n={i18n()}
                                                        data={y}
                                                        title={
                                                          y?.equipment?.name
                                                        }
                                                      />
                                                    </Link>
                                                  </div>
                                                );
                                              }
                                            ))
                                        }
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <EmptyState
                                  title={
                                    i18n(lang).no_area_title
                                  }
                                  description={
                                    i18n(lang).no_area_desc
                                  }
                                  icon={
                                    <svg
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M9.00043 4.75C9.00043 5.30228 8.55272 5.75 8.00043 5.75C7.44815 5.75 7.00043 5.30228 7.00043 4.75C7.00043 4.19772 7.44815 3.75 8.00043 3.75C8.55272 3.75 9.00043 4.19772 9.00043 4.75ZM8.25242 7.73957C8.32725 7.85207 8.39607 7.97018 8.45824 8.09366C8.88606 8.94331 8.93561 9.93401 8.5947 10.8221L8.57865 10.8639C8.47675 11.1294 8.34269 11.3813 8.17945 11.6141L7.01367 13.2768C6.65683 13.7857 5.95498 13.909 5.44604 13.5522C4.9371 13.1953 4.8138 12.4935 5.17064 11.9846L6.33642 10.3219C6.394 10.2398 6.44129 10.1509 6.47723 10.0573L6.49328 10.0154C6.60692 9.71941 6.5904 9.38918 6.4478 9.10596C6.18689 8.5878 5.57485 8.35285 5.03423 8.56335C4.73874 8.67839 4.5055 8.91276 4.39186 9.20879L4.37581 9.2506C4.33987 9.34423 4.31555 9.44192 4.30339 9.54148L4.05719 11.5571C3.98183 12.1741 3.42057 12.6132 2.80358 12.5378C2.18659 12.4625 1.74751 11.9012 1.82287 11.2842L2.06907 9.26858C2.10354 8.98634 2.1725 8.70939 2.2744 8.44394L2.29045 8.40213C2.63135 7.51403 3.33108 6.81095 4.21754 6.4658C4.60307 6.3157 5.00071 6.2411 5.39343 6.23547C5.14334 5.79751 5.00043 5.29045 5.00043 4.75C5.00043 3.09315 6.34358 1.75 8.00043 1.75C9.08252 1.75 10.0308 2.3229 10.5585 3.18193L17.8415 5.98309C18.2321 5.83254 18.6564 5.75 19.1 5.75C21.033 5.75 22.6 7.317 22.6 9.25C22.6 10.6882 21.7326 11.9237 20.4924 12.4621L18.7751 18.25H19.0004C20.105 18.25 21.0004 19.1454 21.0004 20.25C21.0004 21.3546 20.105 22.25 19.0004 22.25H5.00043C3.89586 22.25 3.00043 21.3546 3.00043 20.25C3.00043 19.1454 3.89586 18.25 5.00043 18.25H10.1297L16.1674 11.1612C15.9344 10.8043 15.7647 10.4022 15.6744 9.97093L9.22392 7.48999C8.92305 7.62455 8.59595 7.711 8.25242 7.73957ZM20.35 9.25C20.35 9.94036 19.7904 10.5 19.1 10.5C18.4097 10.5 17.85 9.94036 17.85 9.25C17.85 8.55964 18.4097 8 19.1 8C19.7904 8 20.35 8.55964 20.35 9.25Z"
                                        fill="black"
                                        fill-opacity="0.5"
                                      />
                                    </svg>
                                  }
                                  hasButton
                                  button={
                                    <div
                                      style={{
                                        marginTop: "20px",
                                        marginBottom: "50px",
                                      }}
                                    >
                                      <Link
                                        to="/create-area"
                                        state={{
                                          pageType: "add",
                                          nodeid:
                                            location.state != undefined
                                              ? location.state.nodeid
                                              : value?.nodeid,
                                          sitename: value.name,
                                          sitenodeid: value.nodeid,
                                        }}
                                        style={{
                                          padding: "0px 5px",
                                          color: "#212121",
                                        }}
                                      >
                                        <Button
                                          startIcon={<AddIcon />}
                                          variant="contained"
                                          color="primary"
                                        >
                                          {i18n(lang).create_new_area}
                                        </Button>
                                        <div className="backToDashboard">
                                          <Link to={"/qualitymanagement"}>
                                            {i18n(lang).back_to + " " + i18n(lang).dashboard}
                                          </Link>
                                        </div>
                                      </Link>
                                    </div>
                                  }
                                />
                              )
                            ) : (
                              i18n(lang).area_not_found
                            )
                          ) : (
                            <Stack spacing={1}>
                              <Skeleton
                                animation="wave"
                                width={200}
                                variant="text"
                                sx={{ fontSize: "1rem" }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: "23px",
                                }}
                              >
                                <Skeleton
                                  variant="rounded"
                                  width={425}
                                  height={97}
                                  animation="wave"
                                />
                                <Skeleton
                                  variant="rounded"
                                  width={425}
                                  height={97}
                                  animation="wave"
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginTop: "23px",
                                }}
                              >
                                <Skeleton
                                  variant="rounded"
                                  width={425}
                                  height={97}
                                  animation="wave"
                                />
                                <Skeleton
                                  variant="rounded"
                                  width={425}
                                  height={97}
                                  animation="wave"
                                />
                              </div>
                            </Stack>
                          )}
                        </div>

                        {value?.hasarea ? (
                          <Link
                            to="/create-area"
                            state={{
                              pageType: "add",
                              nodeid:
                                location.state != undefined
                                  ? location.state.nodeid
                                  : value?.nodeid,
                              sitename: value.name,
                              sitenodeid: value.nodeid,
                            }}
                            style={{
                              padding: "0px 5px",
                              color: "#212121",
                            }}
                          >
                            <Button
                              startIcon={<AddIcon />}
                              variant="contained"
                              color="primary"
                              style={{ margin: "20px 0px" }}
                            >
                              {i18n(lang).new_area}
                            </Button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </>
                    </CustomTabPanel>
                  );
                })}
            </Grid>
          </Grid>
        </section>
      )}
    </>
  );
}

export default SitePage;
